export default __webpack_public_path__ + "static/serti-iso-08ab6c199d4e0a69aaf1f7f67513957a.png";